module.exports = __webpack_public_path__ + "img/register-right-bg-first.ab7da0bf.png";